import { render, staticRenderFns } from "./ChatMember.vue?vue&type=template&id=182c7fa1&"
import script from "./ChatMember.vue?vue&type=script&lang=js&"
export * from "./ChatMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports